// import Rellax from 'rellax';
import Lottie from 'lottie-web';

// document.querySelectorAll('.lottie__text__item').forEach(rellax => new Rellax(rellax, {
//   speed: 1,
// }));

const lottieWrapper = document.querySelector('.lottie');

class DpLottie {
  constructor(options) {
    this.container = options.container;
    this.step = 0;
    this.windowStatus = 'unsnapped';
    this.buttons = {
      snap: this.container.querySelector('.js-lottie-snap'),
      unsnap: this.container.querySelector('.js-lottie-unsnap'),
    };
    this.playerDiv = this.container.querySelector('.lottie__player');
    this.playerJson = options.lottieJson;
    this.containerHeight = options.containerHeight;

    this.totalFrames = 1450;
    this.totalTime = 24.166666;

    this.steps = {
      1: { startTime: 0, speed: 2 },
      2: { startTime: 5, speed: 1.8 },
      3: { startTime: 9.6, speed: 2.5 },
      4: { startTime: 16, speed: 2 },
    };

    this.additionalSpeedFactor = 1;

    this.player = Lottie.loadAnimation({
      container: this.playerDiv,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: this.playerJson,
    });
    this.player.setSpeed(this.steps[1].speed);
  }

  setLottieFrame() {
    const lottieHeight = this.bottom - this.top;
    const windowTop = window.scrollY;
    const y = windowTop - this.top;
    let frame = 0;
    if (y > 0) {
      const percent = y / lottieHeight;
      frame = percent * this.totalFrames;
      this.player.goToAndStop(frame, true);
    } else {
      this.player.goToAndStop(0, true);
    }
  }

  setStepByScroll() {
    const lottieHeight = this.bottom - this.top;
    const windowTop = window.scrollY;
    const y = windowTop - this.top;


    if (y > 0) {
      const percent = y / lottieHeight;
      // const percentForWithinItem = percent * 0.8;
      let percentWithinItem;
      if (percent <= 0.2) {
        percentWithinItem = percent / 0.2;
        this.setStep(1);
      } else if (percent <= 0.4) {
        percentWithinItem = (percent - 0.2) / 0.2;
        this.setStep(2);
      } else if (percent <= 0.6) {
        percentWithinItem = (percent - 0.4) / 0.2;
        this.setStep(3);
      } else if (percent <= 0.8) {
        percentWithinItem = (percent - 0.6) / 0.2;
        this.setStep(4);
      } else {
        percentWithinItem = 1;
        this.setStep(5);
      }
      const percentItem = Math.round(percentWithinItem * 100);
      const topItem = `${100 - percentItem}%`;
      this.container.querySelectorAll('.lottie__text__item').forEach((item) => {
        // eslint-disable-next-line no-param-reassign
        item.style.top = topItem;
      });
    } else {
      this.setStep(0);
    }
    const classToAdd = `lottie--step${this.step}`;
    if (this.container.classList.contains(classToAdd)) return;

    this.container.classList.remove('lottie--step0');
    this.container.classList.remove('lottie--step1');
    this.container.classList.remove('lottie--step2');
    this.container.classList.remove('lottie--step3');
    this.container.classList.remove('lottie--step4');
    this.container.classList.remove('lottie--step5');

    this.container.classList.add(`lottie--step${this.step}`);

    // });
  }

  setStep(step) {
    const isNewStep = this.step !== step;
    let direction = 1;
    // check if the new step is smaller than the current step and set direction
    if (step < this.step) {
      direction = -1;
    }

    this.step = step;

    if (step === 0 && direction === 1) return;
    if (isNewStep) {
      // play
      let stepInConfig = step < 4 ? step : 4;
      if (direction === -1) {
        stepInConfig += 1;
      }
      this.player.setSpeed(this.steps[stepInConfig].speed * this.additionalSpeedFactor);
      const { startTime } = this.steps[stepInConfig];
      const startPercent = startTime / this.totalTime;
      const startFrame = startPercent * this.totalFrames;

      let endFrame;
      if (stepInConfig >= 4) {
        endFrame = this.totalFrames - 200;
      } else {
        const endTime = this.steps[stepInConfig + 1].startTime;
        const endPercent = endTime / this.totalTime;
        endFrame = endPercent * this.totalFrames;
      }

      if (step > 4 || (step === 4 && direction === -1)) return;

      // check if the new step is smaller than the current step
      if (direction === -1) {
        // this.player.setDirection(-1);
        this.player.playSegments([endFrame, startFrame], true);
      } else {
        this.player.playSegments([startFrame, endFrame], true);
        // this.player.setDirection(1);
      }
    }
  }

  setStepByFrame(frame) {
    const percent = frame / this.totalFrames;
    const sec = 24 * percent;
    switch (true) {
      case sec <= this.steps[2].startTime:
        this.step = 1;
        break;
      case sec <= this.steps[3].startTime:
        this.step = 2;
        break;
      case sec <= this.steps[4].startTime:
        this.step = 3;
        break;
      default:
        this.step = 4;
    }

    const classToAdd = `lottie--step${this.step}`;
    if (this.container.classList.contains(classToAdd)) return;

    this.container.classList.remove('lottie--step1');
    this.container.classList.remove('lottie--step2');
    this.container.classList.remove('lottie--step3');
    this.container.classList.remove('lottie--step4');

    this.container.classList.add(`lottie--step${this.step}`);
  }

  init() {
    lottieWrapper.style.height = this.containerHeight;

    this.top = lottieWrapper.getBoundingClientRect().top + window.scrollY;
    this.bottom = lottieWrapper.getBoundingClientRect().bottom + window.scrollY;

    // Call checkYPostion on scroll
    // window.addEventListener('scroll', () => { this.setLottieFrame(); });
    window.addEventListener('scroll', () => { this.setStepByScroll(); });

    this.player.goToAndStop(this.startFrame, true);

    /*     this.player.addEventListener('enterFrame', (e) => {
      this.setStepByFrame(e.currentTime);
    }); */
  }
}

window.addEventListener('load', () => {
  if (lottieWrapper) {
    const options = {
      container: lottieWrapper,
      lottieJson: lottieWrapper.dataset.lottieUrl || '/media/animations/lottie.json',
      /*       lottieJson: lottieWrapper.dataset.lottieUrl || {
        1: '/media/animations/lottie1.json',
        2: '/media/animations/lottie2.json',
        3: '/media/animations/lottie3.json',
        4: '/media/animations/lottie4.json',
      }, */
      containerHeight: lottieWrapper.dataset.containerHeight || '400vh',
    };

    const lottie = new DpLottie(options);
    lottie.init();
  }
});
